import React from 'react'

const PricingTableTab = ({checkActiveTab, targetTab, type, packages, checkActivePackage, packageSelect}) => {
  return (
    packages && packages.length > 0 &&
    <div
      className={`tab-pane fade show ${
        checkActiveTab(type) ? "active" : ""
      }`}
      id={targetTab}
      role="tabpanel"
      aria-labelledby={targetTab}
    >
      <div className="pricing-table-heading">
        <div className="pricing-table-heading-body">
          <div className="pricing-item-desc">
            <h4>Our Packages</h4>
          </div>
          {packages && packages[0]?.itemData.map((itemData, index) => (
            <div
              className="pricing-item"
              key={`${type}-head-${index}`}
            >
              <h5>{itemData?.our_package?.name || itemData?.package_name || "Package"}</h5>
            </div>
            )
          )}
        </div>
      </div>

      <div className="pricing-table-content">
        {packages && packages.map((singleData, index) => (
          <div
            className="pricing-table-item"
            key={`single-data-item-${index}`}
          >
            <div className="pricing-item-desc">
              <span>{singleData.item_name}</span>
            </div>
            {singleData.itemData.map((itemData, index) => (
              <div
                className="pricing-item"
                key={`single-data-value-${index}`}
              >
                <p>
                  {isNaN(itemData.value) ? (
                    itemData.value === "true" ? (
                      <span className="icon icon-success">
                        <i className="fadeIn animated bx bx-check"></i>
                      </span>
                    ) : itemData.value === "false" ? (
                      <span className="icon icon-danger">
                        <i className="fadeIn animated bx bx-x"></i>
                      </span>
                    ) : (
                      itemData.value
                    )
                  ) : (
                    `$${itemData.value}`
                  )}
                </p>
              </div>
            ))}
          </div>
        ))}

        <div className="pricing-table-item">
          <div className="pricing-item-desc"></div>

          {packages && packages[0]?.itemData.map(
            (itemData, index) => (
              <div
                className="pricing-item"
                key={`package-item-purchase-single-${index}`}
              >
                <button
                  className="btn btn-primary submit-type radius-30"
                  onClick={packageSelect.bind(this, {
                    package: itemData?.our_package?.id ?? itemData?.our_package_id,
                    package_name: itemData?.our_package?.name || itemData?.package_name || "Package",
                    billed:
                      itemData?.our_package?.package_type?.type || itemData?.package_type || type,
                    price: itemData.value,
                  })}
                  disabled={checkActivePackage(
                    itemData?.our_package?.id ?? itemData?.our_package_id
                  )}
                >
                  Process
                </button>
              </div>
            )
            )}
        </div>
      </div>
    </div>
  )
}

export default PricingTableTab
